import { useCachedApiCall } from '@hooks/apiCall';
import type { DepartmentParams } from '@api/DepartmentService';
import { departmentCache, orgDepartmentsCache } from './departmentStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed detail of a department. */
export const useDepartmentEntry = (
    departmentId?: string,
    params?: DepartmentParams,
) => useCachedApiCall(departmentCache, [departmentId, params], [departmentId]);

/** Cache-backed department list of an organization. */
export const useOrgDepartmentsEntry = (orgId?: string) =>
    useCachedApiCall(orgDepartmentsCache, [orgId]);
